// Students named on a class's re-grade requests. One entry per student,
// even when that student is on more than one of the three batches.

function clean(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

function rollOf(student) {
  const direct = clean(student && student.roll).toLowerCase();
  if (direct) return direct;
  const fromName = clean(student && (student.studentName || student.name)).match(/\(([^)]+)\)/);
  return fromName ? fromName[1].trim().toLowerCase() : '';
}

function displayName(student, roll) {
  const full = clean(student && student.studentName);
  if (full) return full;
  const name = clean(student && student.name);
  if (roll && name && !/\([^)]+\)/.test(name)) return `(${roll.toUpperCase()}) ${name}`;
  if (name) return name;
  return roll ? `(${roll.toUpperCase()})` : '';
}

export function listRegradeStudents(requests) {
  const byId = new Map();
  const batches = Array.isArray(requests) ? requests : [];
  for (const batch of batches) {
    const students = batch && Array.isArray(batch.students) ? batch.students : [];
    for (const student of students) {
      if (!student || typeof student !== 'object') continue;
      const roll = rollOf(student);
      const name = displayName(student, roll);
      if (!name) continue;
      const id = roll ? `roll:${roll}` : `name:${name.toLowerCase()}`;
      const prev = byId.get(id);
      if (!prev || name.length > prev.name.length) {
        byId.set(id, { key: id, roll, name });
      }
    }
  }
  return [...byId.values()].sort((a, b) => a.name.localeCompare(
    b.name,
    undefined,
    { numeric: true, sensitivity: 'base' }
  ));
}
